import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/constants/site";

export const QuickContact = () => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 1.4, duration: 0.5 }}
    className="fixed bottom-6 right-5 z-50 flex flex-col gap-3"
  >
    <a href={SITE.phoneHref} data-testid="call-quick-btn" aria-label="Call Orion Edcon"
      className="w-12 h-12 rounded-full bg-[#0B192C] text-white flex items-center justify-center shadow-lg ring-1 ring-amber-500/40 hover:bg-amber-600 hover:scale-105 transition-all duration-300">
      <Phone className="w-5 h-5" />
    </a>
    <a href={SITE.whatsapp} target="_blank" rel="noreferrer" data-testid="whatsapp-quick-btn" aria-label="Chat on WhatsApp"
      className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-xl hover:scale-105 transition-transform duration-300">
      <MessageCircle className="w-7 h-7" />
    </a>
  </motion.div>
);
